import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { afterItems, beforeItems, principleSteps } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="before-after" data-id="element-41" data-mp="3oi42b6rjhndu">
      <div className="mx-auto max-w-6xl" data-id="element-42" data-mp="3sfjpsxfvp31x">
        <SectionHeading kicker="From confusing codes to a structured process" title={<span id="before-after" data-id="element-44" data-mp="3jgy8t6q21w39">
              Stop replacing parts on assumptions. <span className="text-amber" data-id="element-45" data-mp="34rse9w25wu1p">Start investigating on evidence.</span>
            </span>} subtitle="A trouble code points you toward a system or operating condition — it doesn’t automatically tell you which component has failed." data-id="element-43" data-mp="3epg7ghk4dthr" />

        <ol className="mx-auto mb-14 grid max-w-4xl grid-cols-2 gap-3 md:grid-cols-4" data-id="element-46" data-mp="2vrvqdwnljz7p">
          {principleSteps.map((step, i) => <li key={step} className="rounded-xl border border-line bg-panel px-4 py-4 text-center" data-id="element-47" data-mp="x4aczaj49n02" data-mpi={i}>
              <span className="font-display text-3xl font-extrabold text-amber" data-id="element-48" data-mp="t38jlabvs560">{i + 1}</span>
              <p className="mt-1 font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-49" data-mp="172hqtki3zoxu">{step}</p>
            </li>)}
        </ol>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-50" data-mp="1246en34cd2cg">
          <div className="rounded-2xl border-2 border-signal/60 bg-[#140A10] p-5 sm:p-7" data-id="element-51" data-mp="edsurzvwu9sy">
            <h3 className="flex items-center gap-3 font-display text-3xl font-extrabold uppercase text-[#FF6B66]" data-id="element-52" data-mp="9f9ae3wyt62p">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-signal" data-id="element-53" data-mp="o4dvbsv59oei">
                <XIcon className="h-5 w-5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-54" data-mp="jcndl1tvnyd2" />
              </span>
              Before the Blueprint
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-55" data-mp="3rqw32113s910">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-[#E6D3D5]" data-id="element-56" data-mp="3mrrt386cu79m">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-signal" strokeWidth={3} aria-hidden="true" data-id="element-57" data-mp="1qowt7kjxu67e" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-ok/70 bg-[#08180F] p-5 sm:p-7" data-id="element-58" data-mp="20iwv7djxavbw">
            <h3 className="flex items-center gap-3 font-display text-3xl font-extrabold uppercase text-ok" data-id="element-59" data-mp="24k8lzmej9mlo">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ok" data-id="element-60" data-mp="17u80pxddho94">
                <CheckIcon className="h-5 w-5 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-61" data-mp="1ct2lh4uwhmvv" />
              </span>
              With the Blueprint
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-62" data-mp="1lsfu5vb7a7fj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-white" data-id="element-63" data-mp="2s6owgvq6v1yh">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-64" data-mp="2x5rys8esau2r" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg text-mist" data-id="element-65" data-mp="32c6x4lahkjx7">
          The goal isn’t to replace your experience. It’s to help you use your experience{' '}
          <strong className="text-white" data-id="element-66" data-mp="2tiae3fcmbnm0">more systematically.</strong>
        </p>

        <CtaButton className="mt-8" label="Show me the diagnostic system" sub="Instant access · $27 one-time" data-id="element-67" data-mp="2oks2tib4owau" />
      </div>
    </section>;
}